import { Branch, BranchStats, CreateBranchRequest, UpdateBranchRequest } from '@/types/branches'
import { createAuthenticatedApi, extractApiErrorMessage } from '@/lib/api'

interface BranchResponse {
  success: boolean
  data: Branch
}

interface BranchListResponse {
  success: boolean
  data: Branch[]
  count: number
}

interface BranchStatsResponse {
  success: boolean
  data: BranchStats
}

const api = createAuthenticatedApi()

export const getBranches = async (): Promise<Branch[]> => {
  try {
    const response = await api.get<BranchListResponse>('/branches')
    return response.data.data
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to fetch branches'))
  }
}

export const getBranchById = async (id: string): Promise<Branch> => {
  try {
    const response = await api.get<BranchResponse>(`/branches/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to fetch branch'))
  }
}

export const createBranch = async (data: CreateBranchRequest): Promise<Branch> => {
  try {
    const response = await api.post<BranchResponse>('/branches', data)
    return response.data.data
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to create branch'))
  }
}

export const getBranchStats = async (id: string): Promise<BranchStats> => {
  try {
    const response = await api.get<BranchStatsResponse>(`/branches/${id}/stats`)
    return response.data.data
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to fetch branch statistics'))
  }
}

export const updateBranch = async (data: UpdateBranchRequest): Promise<Branch> => {
  try {
    const response = await api.put<BranchResponse>(`/branches/${data.id}`, data)
    return response.data.data
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to update branch'))
  }
}

export const deleteBranch = async (id: string): Promise<void> => {
  try {
    await api.delete(`/branches/${id}`)
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'Failed to delete branch'))
  }
}
